// import { http } from "@/libs/axios.js";
import Vue from "vue";

export const vacationAPI = {
  productFilter: "product/product/line-filter",
  productList: "product/product/line-list",
  productDetail: "product/product/line-info",
  productDates: "product/product/line-dates",
  productDst: "product/product/line-date-dst", // 产品出发地
  productPrices: "product/product/line-date-dst-prices",

  bookingInfo: "order/submit/line-booking-info",

  createOrder: "order/submit/line-create"
  // procueBooking: '/order/submit/line-booking'
};
export function getProductFilter() {
  return Vue.$axios.$post(vacationAPI.productFilter);
}

export function getProductList(data = {}) {
  return Vue.$axios.$post(vacationAPI.productList, { data });
}

export function getProductDetail(data = {}) {
  return Vue.$axios.$post(vacationAPI.productDetail, { data });
}

export function getProductDates(data = {}) {
  return Vue.$axios.$post(vacationAPI.productDates, { data });
}

// 获取出发地
export function getProductDst(data = {}) {
  return Vue.$axios.$post(vacationAPI.productDst, { data });
}

// 获取价格
export function getProductPrices(data = {}) {
  return Vue.$axios.$post(vacationAPI.productPrices, { data });
}

export function getBookingInfo(data = {}) {
  return Vue.$axios.$post(vacationAPI.bookingInfo, { data });
}

export function createOrder(data = {}) {
  return Vue.$axios.$post(vacationAPI.createOrder, { data });
}
